module.exports = __webpack_public_path__ + "static/media/lord.fe520d62.mp4";